<template>
    <section class="call-action" :class="data.class">
        <div class="clip-path-cta"></div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-9">		
                    <h1>{{ data.title.before }} <br>{{ data.title.after }}</h1>
                </div>
                <div class="col-md-3">	
                    <router-link :to="data.button.link" tag="a" class="btn btn-viitra-dark">
                        {{ data.button.text }}
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['data'],        
    }
</script>



// WEBPACK FOOTER //
// src/components/CallToAction.vue